module.exports = __webpack_public_path__ + "static/media/rotate_img_proj.f20b44dc.gif";